import { render, staticRenderFns } from "./add-opinion.vue?vue&type=template&id=7fb7231d&scoped=true"
import script from "./add-opinion.vue?vue&type=script&lang=js"
export * from "./add-opinion.vue?vue&type=script&lang=js"
import style0 from "./add-opinion.vue?vue&type=style&index=0&id=7fb7231d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb7231d",
  null
  
)

export default component.exports